import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import HomePage from "./pages/HomePage";
import ServicesHub from "./pages/ServicesHub";
import ServiceDetail from "./pages/ServiceDetail";
import ContactPage from "./pages/ContactPage";
import CommercialPage from "./pages/CommercialPage";
import SchedulePage from "./pages/SchedulePage";
import McKinneyPage from "./pages/locations/McKinneyPage";
import PlanoPage from "./pages/locations/PlanoPage";
import AllenPage from "./pages/locations/AllenPage";
import FriscoPage from "./pages/locations/FriscoPage";
import RichardsonPage from "./pages/locations/RichardsonPage";
import WyliePage from "./pages/locations/WyliePage";
import MurphyPage from "./pages/locations/MurphyPage";
import LucasPage from "./pages/locations/LucasPage";
import FairviewPage from "./pages/locations/FairviewPage";
import GoogleAdsLandingPage from "./pages/GoogleAdsLandingPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import NotFoundPage from "./pages/NotFoundPage";

// Shared
import { BoatmanAI } from "./components/shared/BoatmanAI";
import { ScrollToTop } from "./components/shared/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesHub />} />
          <Route path="/services/:serviceId" element={<ServiceDetail />} />
          <Route path="/commercial" element={<CommercialPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/contact/:serviceId" element={<ContactPage />} />
          <Route path="/schedule" element={<SchedulePage />} />
          <Route path="/landing-google-ads" element={<GoogleAdsLandingPage />} />
          <Route path="/locations/mckinney" element={<McKinneyPage />} />
          <Route path="/locations/plano" element={<PlanoPage />} />
          <Route path="/locations/allen" element={<AllenPage />} />
          <Route path="/locations/frisco" element={<FriscoPage />} />
          <Route path="/locations/richardson" element={<RichardsonPage />} />
          <Route path="/locations/wylie" element={<WyliePage />} />
          <Route path="/locations/murphy" element={<MurphyPage />} />
          <Route path="/locations/lucas" element={<LucasPage />} />
          <Route path="/locations/fairview" element={<FairviewPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <BoatmanAI />
      </BrowserRouter>
    </div>
  );
}

export default App;
